import { render, staticRenderFns } from "./ModalComment.vue?vue&type=template&id=5b1b9d5c&scoped=true"
import script from "./ModalComment.vue?vue&type=script&lang=js"
export * from "./ModalComment.vue?vue&type=script&lang=js"
import style0 from "./ModalComment.vue?vue&type=style&index=0&id=5b1b9d5c&prod&lang=scss&scoped=true"
import style1 from "./ModalComment.vue?vue&type=style&index=1&id=5b1b9d5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b9d5c",
  null
  
)

export default component.exports